/** @jsxImportSource @emotion/react */
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link, useParams } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Button, css, Grid, Typography } from '@mui/material';
import Header from 'components/Header';
import { TXT_BACK, TXT_EDIT, TXT_MENU, TXT_YOUR_ORDER } from 'translations';
import { ROUTES } from 'utils/routes';

const CheckoutHeader: FC<{ isEditable: boolean }> = ({ isEditable }) => {
  const { t } = useTranslation();
  const { dayDate, userId } = useParams<{ dayDate: string; userId: string }>();

  return (
    <Header>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        wrap="nowrap"
        gap="10px"
        css={css`
          padding-top: 4px;
          padding-bottom: 4px;
        `}
      >
        <Grid item>
          <Button
            component={Link}
            variant="contained"
            startIcon={<ArrowBackIosIcon />}
            to={generatePath(ROUTES.WEEK, { userId })}
          >
            {t(TXT_BACK)}
          </Button>
        </Grid>
        <Grid item>
          <Typography variant="h2" textTransform="uppercase" textAlign="center">
            {t(TXT_YOUR_ORDER)}
          </Typography>
        </Grid>

        <Grid item>
          <Button
            component={Link}
            to={generatePath(ROUTES.MENU_CURRENT_DAY, { dayDate, userId })}
          >
            {t(isEditable ? TXT_EDIT : TXT_MENU)}
          </Button>
        </Grid>
      </Grid>
    </Header>
  );
};

export default memo(CheckoutHeader);
